import { render, staticRenderFns } from "./InsolvencyPractitionerTaskQueue.vue?vue&type=template&id=63104650&scoped=true&"
import script from "./InsolvencyPractitionerTaskQueue.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPractitionerTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPractitionerTaskQueue.vue?vue&type=style&index=0&id=63104650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63104650",
  null
  
)

export default component.exports